import PropTypes from 'prop-types';
import { WidgetPreviewContainer } from 'decap-cms-ui-default';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function UuidPreview({
  value
}) {
  return _jsx(WidgetPreviewContainer, {
    children: value
  });
}
UuidPreview.propTypes = {
  value: PropTypes.node
};
export default UuidPreview;